module.exports = __webpack_public_path__ + "img/box6_img3.20652709.jpg";